import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LoadingProvider } from './context/LoadingProvider'; 
import AppRouters from './components/AppRouters';

const App = () => {
  return (
    <Router>
      <LoadingProvider>
        <AppRouters />
      </LoadingProvider>
    </Router>
  );
};

export default App;
